import { useEffect, type ReactElement } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "@/components/shared/LoadingSpinner/LoadingSpinner";
import { useTranslations } from "@/hooks/useTranslations";
import { authService } from "@/services/authService";

export function AuthRedirectRoute(): ReactElement {
  const navigate = useNavigate();
  const { inProgress } = useMsal();
  const { t, translations } = useTranslations();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    navigate(authService.consumePostLoginRedirectPath(), { replace: true });
  }, [inProgress, navigate]);

  const message = translations ? t("app.loadingAuthentication") : "Authenticating...";

  return <LoadingSpinner message={message} fullScreen />;
}